import {FieldProps} from "./index";
import React from "react";
import {Label} from "./Label";

export const Input = (props: FieldProps & any): JSX.Element => {
    const {label, onChange, className, borderColor, ...passedProps} = props;

    return (
        <div className={className}>
            <Label label={label}/>
            <input onChange={(e) => onChange(e.target.value, props.value)} {...passedProps}
                   className={`w-full appearance-none rounded-md border-2 ${borderColor ?? "border-neutral-300"} bg-transparent py-2 px-3 leading-tight`}/>
        </div>
    );
};
